import { styled } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

export const StyledMoreDetailsIcon = styled(SWReactIcons)`
    display: var(--more-details-icon-display);
`;

export const FilterLabelWrapper = styled.div`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    min-width: 0;
`;

export const CitationLink = styled.a`
    color: ${colorsPalettes.blue[300]};
`;
